<div class="card-anuncio">
    <!-- Icono SVG -->
    <img src="../../assets/img/employee.svg">
    
    <!-- Texto del anuncio -->
    <div class="card-texto">
        ¡Selecciona una vacante!
    </div>
</div>